import { useStore } from 'zustand';
import { useShallow } from 'zustand/shallow';

import { inventoryStore } from '../InventoryStore';

/**
 * Optimized selector hook for Tabs component
 * Uses shallow comparison to prevent unnecessary re-renders
 *
 * @returns Selected tab inventory state and actions
 */
export const useTabInventoryState = () => {
  return useStore(
    inventoryStore,
    useShallow((state) => ({
      inventoryRooms: state.inventoryRooms,
      inventory: state.inventory,
      dependencies: state.dependencies,
      rawInventory: state.rawInventory,
      modifiedInventory: state.modifiedInventory,
      timePeriodStore: state.timePeriodStore,
      setInventory: state.setInventory,
      hasDeactivatedPricingRuleByEdit: state.hasDeactivatedPricingRuleByEdit,
    }))
  );
};

/**
 * Optimized selector hook for form instance
 * Isolated to prevent re-renders when other state changes
 *
 * @returns Form instance from store
 */
export const useInventoryForm = () => {
  return useStore(inventoryStore, (state) => state.form);
};
